import {
  Grid,
  Typography,
  styled,
  Radio,
  Box,
  FormControlLabel,
  InputAdornment,
  DialogContent,
  DialogTitle,
  Dialog
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import styles from "../devoteeService.module.scss";
import { ValidationError, number, object, string } from "yup";
import { useEffect, useState } from "react";
import constants from "../../../config/constants.json";
import dayjs from "dayjs";
import LOCALE from "../../../config/en-us.json";
import IconButton from "@mui/material/IconButton";
import cartIcon from "../../../assets/svg/Cart.svg";
import {
  CustomRequiredInputLabel,
  CustomRadioButton,
  CustomSelect,
  CustomMenuItem,
  StyledDateContainer,
  CustomDatePicker,
  CustomCalendarTodayOutlinedIcon,
  CustomBadge,
  CustomTextFeild,
  CommonButton,
  CustomLeftIcon,
  CustomCheckbox,
  CommonOutlinedButton,
} from "../../common/StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserName,
  getUserRoleId,
  getaccessToken,
} from "../../../infrastructure/backendService";
import toast, { Toaster } from "react-hot-toast";
import HcccTimePicker from "../../common/customTimePicker/hcccTimePicker";
import { isEmpty, isNil } from "lodash";
import apiPath from "../../../config/apiPaths.json";
import {
  DietiesListByPoojaIdProps,
  PoojaTypeListProps,
  PriestListProps,
  cartItemListProps,
} from "../../../infrastructure/GlobalContextProvider";
import { ClipLoader } from "react-spinners";
import ManagerCartItemsComponent from "../../managerDashboard/managerCartItems/managerCartItems";
import { useNavigate, useSearchParams } from "react-router-dom";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { ASP_BASE_URL } from '../../../config/apiUrl';
import CloseIcon from "@mui/icons-material/Close";
import { BounceLoader } from 'react-spinners';
import { getStartTimeAndEndTime, handlePoojaTimeChangeSetErrors } from "../../common/handleTimeChangeSetErrors";

type ErrorPoojaItem = {
  name: string;
  poojaDate: string;
  pooja: string;
  poojaTitle: string;
  selectPriest: string;
  deities: string;
  dateOfPooja: string;
  donationAmount: string;
  poojaLocation: string;
  poojaTime: string;
};

interface PoojaItem {
  id?: number | null | undefined;
  name: string | null;
  poojaTitle: string;
  deities: string;
  dateOfPooja: string;
  donationAmount: number;
  poojaLocation: string;
  poojaTime: string;
  selectPriest: string;
  poojaDuration: number;
}
interface PoojaBookingProps {
  onBackClick: () => void;
}

export const CustomRadioButtons = styled(Radio)`
  & svg {
    color: #f05802;
    height: 20px;
    width: 20px;
  }
`;

const PoojaBooking = (props: PoojaBookingProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [poojaItemsList, setPoojaItemsList] = useState<any[]>([]);
  // for ASP modifications
  const [searchParam] = useSearchParams();
  const PoojaId = searchParam.get("PoojaId");
  const priestId = searchParam.get("priestName");
  const start_date = dayjs(searchParam.get("start_date"), "MM-DD-YYYY") || "";
  const completeDate = start_date.isValid() ? start_date.format("MM-DD-YYYY") : "";
  const start_time = searchParam.get("start_time");
  const poojaLocation = searchParam.get("location");
  const poojaMins = searchParam.get("poojaMins") || 0;
  const selectedPoojaName = poojaItemsList.find(
    (item: PoojaTypeListProps) => item.id === parseFloat(PoojaId || "")
  );
  const storageAmount = searchParam.get("poojaAmount");
  const storagePoojaDuration = sessionStorage.getItem("poojaDuration");
  const showAmountAndDuration = (): boolean => {
    if (isNil(PoojaId) || isNil(priestId)) {
      return false;
    } else {
      return true;
    }
  };
  const [poojaName, setPoojaName] = useState<string>("");
  //
  const [showList, setShowList] = useState<boolean>(false);
  const [showDeities, setShowDeities] = useState<boolean>(showAmountAndDuration());
  const [priestList, setPriestList] = useState<PriestListProps[]>([]);
  const [showPriestDropdown, setShowPriestDropdown] = useState<boolean>(showAmountAndDuration());
  const [buttonDisable, setButtonDisable] = useState<boolean>(false);
  const [priestSelected, setPriestSelected] = useState<boolean>(showAmountAndDuration());
  const [todayScheduleList, setTodayScheduleList] = useState<string[] | []>([]);
  const [selectedDeityIds, setSelectedDeityIds] = useState<number[]>([]);
  const [selectedPoojaId, setSelectedPoojaId] = useState<number | null>(
    !isNil(PoojaId) ? parseInt(PoojaId, 10) : null
  );
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [selectedPriestId, setSelectedPriestId] = useState<string | undefined>(
    ""
  );
  const [poojaDeitiesList, setPoojaDeitiesList] = useState<
    DietiesListByPoojaIdProps[]
  >([]);
  const [cartItemIds, setCartItemIds] = useState<any[]>([]);
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [deityError, setDeityError] = useState<string>("");
  const [formData, setFormData] = useState({
    name: getDevoteeId()?.userId || "",
    poojaLocation: poojaLocation || "TEMPLE_POOJA",
    poojaTitle: `${selectedPoojaId}` || "",
    deities: "",
    dateOfPooja: completeDate || dayjs().format("MM-DD-YYYY"),
    donationAmount: parseFloat(storageAmount || "") || 0,
    poojaTime: start_time || dayjs().format("hh:mm A"),
    selectPriest: priestId || "",
    poojaDuration: parseFloat(storagePoojaDuration || "") || 0,
  });
  const [errorMessage, setErrorMessage] = useState<ErrorPoojaItem>({
    name: "",
    poojaLocation: "",
    selectPriest: "",
    poojaTitle: "",
    pooja: "",
    poojaDate: "",
    deities: "",
    dateOfPooja: "",
    donationAmount: "",
    poojaTime: "",
  });
  const [showPriestSchedule, setShowPriestSchedule] = useState<boolean>(false);
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [selectedItems, setSelectedItems] = useState<number[]>(selectedDeityIds);
  const [donationAmount, setDonationAmount] = useState<number | string>(''); 
  const [duration, setDuration] = useState(Number(poojaMins));

  const navigate = useNavigate();
  
  const maxFieldLimit = constants.Maximum_Field_LIMIT; 

  useEffect(() => {
    getCartItems();
  }, []);

  useEffect(() => {
    // Recalculate donation amount whenever currentItem or selectedItems change
    setDonationAmount(calculateDonationAmount(formData));
    if (formData.poojaTitle !== PoojaId) {
      setDuration(calculateDuration(formData));
    }
    setErrorMessage((prevState) => ({...prevState, donationAmount: ""}))
  }, [formData, selectedItems]);
  function convertDateFormat(dateString: any) {
    const parts = dateString.split('-');
    return parts[0] + '/' + parts[1] + '/' + parts[2];
  }

  const handleTimeChangeSetErrors = (timeRange: any) => {
    handlePoojaTimeChangeSetErrors({
      ...timeRange,
      currentItem: formData,
      errorMessage,
      duration,
      setErrorMessage,
      setButtonDisable,
      isPastDateTimeAllowed: true,
      considerOnlyBookingTime: true
    });
  }

  useEffect(() => {
    if (formData.poojaTime && formData.poojaLocation === "OUTSIDE_POOJA") {
      handleTimeChangeSetErrors(constants.OUTSIDE_POOJA_TIMINGS);
    } else {
      if (formData.poojaTime) {
        handleTimeChangeSetErrors(constants.TEMPLE_POOJA_TIMINGS);
      }
    }
  }, [formData.dateOfPooja, formData.poojaTime, duration]);

  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: getDevoteeId()?.userId,
      },
    })
      .then((res) => {
        setShowList(false);
        const cartItemObjects = res.data.bookedItemInCart.map(
          (item: cartItemListProps) => ({
            itemId: item.id, // Create an object with itemId as the key and item's id as the value
          })
        );
        setcartItemsList(res.data.bookedItemInCart);
        setCartItemIds(cartItemObjects);
        setTotalDonationAmount(res.data.totalAmount);
      })
      .catch((err) => {
        console.log(err);
        setShowList(false);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const validationSchema = object().shape({
    name: string().required("Name is required"),
    poojaLocation: string().required("Pooja Location is required"),
    poojaTitle: string().required("Pooja Title is required"),
    dateOfPooja: string().required("Pooja Date is required"),
    donationAmount: number()
    .required("Donation amount is required")
    .min(1, "Minimum donation amount is 1")
    .max(maxFieldLimit, "Maximum donation amount reached")
    .transform((value, originalValue) => {
      return originalValue === "" ? undefined : value}),
    poojaTime: string().required("Pooja Time is required"),
    selectPriest: showPriestDropdown? string().required("Priest is required"): string()
  });

  const validateDonationSchema = number()
    .required("Donation amount is required")
    .min(1, "Minimum donation amount is 1")
    .max(maxFieldLimit, "Maximum donation amount reached")
    .transform((value, originalValue) => {
      return originalValue === "" ? undefined : value;
    });


    const isPastDateTime = (selectedDateTime: string): boolean => {
      const selectedDate = new Date(selectedDateTime);
      const currentDate = new Date();
      return selectedDate < currentDate;
    };

  const handleSave = async (): Promise<void> => {
    const errors: ErrorPoojaItem = {
      name: "",
      poojaLocation: "",
      poojaTitle: "",
      pooja: "",
      poojaDate: "",
      selectPriest: "",
      deities: "",
      dateOfPooja: "",
      donationAmount: "",
      poojaTime: "",
    };
    let donationAmountError = ""
    let poojaTimeError = errorMessage.poojaTime;
    try {
      await validateDonationSchema.validate(donationAmount, {
        abortEarly: false,
      });
      setErrorMessage({...errors, donationAmount: "", poojaTime: poojaTimeError});
    } catch (error: any) {
      if (error instanceof ValidationError) {
        donationAmountError = error.message
        setErrorMessage({ ...errors, donationAmount: error.message, poojaTime: poojaTimeError });
      }
    }
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      if (showPriestSchedule && !isPastDateTime(`${formData.dateOfPooja} ${formData.poojaTime}`)) {
        toast.custom(
          <ErrorPopup
            showMessage={"Please schedule the priest before proceeding."}
            headerTitle="Attention"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      } else {
        if (!donationAmountError && !poojaTimeError) {
          setErrorMessage(errors)
          poojaAddApi();
        }
      }

    } catch (error: any) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e: any) => {
          if (e.path) {
            errors[e.path as keyof ErrorPoojaItem] = e.message;
          }
        });
      }
      setErrorMessage({...errors, donationAmount: donationAmountError});
    }
  };

  const poojaAddApi = () => {
    if (selectedDeityIds.length === 0 && priestSelected === false && poojaDeitiesList.length !== 0) {
      setDeityError("Deity is Mandatory,Please Select Deity.");
    } else {
      const reqBody = {
        onBehalfOfUsername: getDevoteeId()?.userId?.toUpperCase(),
        poojaType: formData.poojaLocation,
        poojaId: selectedPoojaId,
        priestId: priestSelected ? formData.selectPriest : "",
        deityIds: selectedDeityIds,
        poojaDate: formData.dateOfPooja,
        durationInMinutes: duration.toString(),
        amount: donationAmount.toString(),
        description: "",
        priestRequired: priestSelected,
        poojaTime: formData.poojaTime,
      };
      setLoading(true);
      apiRequest({
        method: "POST",
        endpoint: apiPath.devoteePoojaBookingRequest,
        body: JSON.stringify(reqBody),
        includeToken: true,
      })
        .then((res) => {
          // toast.custom(<ToastSuccess message={res.data} />);
          toast.custom(<SuccessPopup headerMessage="Confirmed" showMessage={LOCALE.ADDED_TO_CART} isOpen={isOpen} setIsOpen={setIsOpen}  />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            });
          setLoading(false);
          getCartItems();
          onClickCancel();
          setShowDetails(false);
          navigate({
            pathname: window.location.pathname,
          });
        })
        .catch((err) => {
          setLoading(false);
          console.log(err, "err");
          toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
            duration: constants.TOAST_POPUP_DURATION,
          });
        });
    }
  };

  const onClickCancel = () => {
    setFormData({
      name: getDevoteeId()?.userId?.toUpperCase() || "",
      poojaLocation: poojaLocation || "TEMPLE_POOJA",
      poojaTitle: selectedPoojaName?.name || "",
      deities: "",
      dateOfPooja: dayjs().format("MM-DD-YYYY"),
      donationAmount: 0,
      poojaTime: dayjs().format("hh:mm A"),
      selectPriest: priestId || "",
      poojaDuration: 0,
    });
    // setcartItemsList([]);
    setTotalDonationAmount(0);
    setPriestSelected(false);
    setShowPriestDropdown(false);
    setSelectedPriestId("");
    setSelectedDeityIds([]);
    setSelectedPoojaId(null);
    setPoojaDeitiesList([]);
    setErrorMessage({ ...errorMessage, poojaTime: "", poojaDate:"", poojaTitle:""});
    setShowDetails(false);
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.poojaTypeByPoojaLocation,
      params: {
        poojaType: formData.poojaLocation,
      },
      includeToken: true,
    })
      .then((res) => {
        setPoojaItemsList(res.data);
        //   setDonationHistoryData(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
        // setDonationHistoryData(data);
        // comment this line after getting response 200 from the server
      });
  }, [formData.poojaLocation]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.priestList,
      includeToken: true,
    })
      .then((res) => {
        setPriestList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);

  const getDeitiesListByPoojaId = (id: number | undefined) => {
    if (!isNil(id)) {
      apiRequest({
        method: "GET",
        endpoint: apiPath.deitiesListByPoojaId,
        includeToken: true,
        params: {
          poojaId: id,
        },
      })
        .then((res) => {
          setPoojaDeitiesList(res.data);
        })
        .catch((err) => {
          console.log(err);
          toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
            duration: constants.TOAST_POPUP_DURATION,
          });
        });
    }
  };

  const handleDropdowmChange = (field: any, value: any) => {
    setButtonDisable(false);
    setShowDeities(true);
    setSelectedItems([]);
    setErrorMessage({ ...errorMessage, [field]: "" });
    if (field === "poojaTitle") {
      setFormData((prevItem) => ({
        ...prevItem,
       selectPriest: ""
      }));
      setSelectedDeityIds([]);
      setShowDetails(true);
      const selectedPooja = poojaItemsList.find(
        (item: PoojaTypeListProps) => item.id === value
      );
      setSelectedPoojaId(selectedPooja?.id);
      getDeitiesListByPoojaId(selectedPooja?.id);
      // Check if priest is required for the selected pooja
      if (selectedPooja && selectedPooja.priestRequired) {
        setShowPriestDropdown(true);
        // setButtonDisable(true);
        setPoojaName(selectedPooja?.name)
        // Show the priest list dropdown
      } else {
        setShowPriestDropdown(false);
        // setButtonDisable(false);
        setPriestSelected(false);
        // Hide the priest list dropdown
      }
      setPriestSelected(false);

      // Set the suggested donation amount for the selected pooja
      setErrorMessage({ ...errorMessage, donationAmount: "" });
      sessionStorage.setItem("poojaAmount", selectedPooja ? selectedPooja.suggestedDonation : 0);
      sessionStorage.setItem("poojaDuration", selectedPooja ? selectedPooja.duration : 0);
      setFormData((prevItem) => ({
        ...prevItem,
        donationAmount: selectedPooja ? selectedPooja.suggestedDonation : 0,
        poojaDuration: selectedPooja ? selectedPooja.duration : 0,
      }));
      setFormData((prevItem) => ({ ...prevItem, [field]: value }));
    } else if (field === "selectPriest") {
      setShowPriestSchedule(true);
      const selectedPriestIds = priestList.find(
        (item: PriestListProps) => item.priest_id === value
      );
      setPriestSelected(true);
      setFormData((prevItem) => ({ ...prevItem, [field]: value }));
      // setButtonDisable(false);
      setSelectedPriestId(selectedPriestIds?.priest_id);
    } else {
      setShowPriestSchedule(false);
      setFormData((prevItem) => ({ ...prevItem, [field]: value }));
      // setShowDeities(true);
      setPriestSelected(false);
    }
  };

  const handleCart = (): void => {
    if (cartItemsList.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const handleCheckboxChange = (label: number) => {
    const isSelected = selectedDeityIds.includes(label);
    setDeityError("");
    if (isSelected) {
      setSelectedDeityIds(selectedDeityIds.filter((item) => item !== label));
    } else {
      setSelectedDeityIds([...selectedDeityIds, label]);
    }

    setSelectedItems(prevSelectedItems => {
      if (prevSelectedItems.includes(label)) {
        return prevSelectedItems.filter(item => item !== label);
      } else {
        return [...prevSelectedItems, label];
      }
    });
  };

  const deitiesListComponent = () => {
    return (
      <div style={{ width: "100%" }}>
        {CustomRequiredInputLabel("Deities", true)}
        <div className={styles.checkBoxContainer}>
          {poojaDeitiesList.map((item: DietiesListByPoojaIdProps, index) => (
            <div className={styles.checkTitle}>
              <FormControlLabel
                control={
                  <CustomCheckbox
                  id="dietiesCheckbox"
                    size="medium"
                    className={styles.checkbox}
                    checked={selectedDeityIds.includes(item.deityId)}
                    onChange={() => handleCheckboxChange(item.deityId)}
                  />
                }
                label={item.deityName}
              />
            </div>
          ))}
        </div>
        {!isEmpty(deityError) ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {deityError}
          </Typography>
        ) : (
          ""
        )}
      </div>
    );
  };

  const handleFieldChange = (field: any, value: any) => {
    if (field === "donationAmount") {
      sessionStorage.setItem("poojaAmount", value);
      setFormData((prevItem) => ({ ...prevItem, [field]: value }));
      setErrorMessage({ ...errorMessage, [field]: "" });
    } else {
      setFormData((prevItem) => ({ ...prevItem, [field]: value }));
      if (field !== "poojaTime") {
        setErrorMessage({ ...errorMessage, [field]: "" });
      }
    }
  };

  const priestListDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          placeholder="Select Priest"
          value={formData.selectPriest || ""}
          onChange={(e) => {
            handleDropdowmChange("selectPriest", e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.selectPriest ? styles.errorTextField : styles.textField
          }
        >
          {priestList.map((item: PriestListProps, index: number) => (
            <CustomMenuItem key={index} value={item.priest_id}>
              {item.priestname}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.selectPriest ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.selectPriest}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const buttonsComponent = (): React.ReactElement => {
    return (
      <div className={styles.buttonsContainer}>
        <CommonOutlinedButton onClick={onClickCancel}>
          Reset
        </CommonOutlinedButton>
        <CommonButton onClick={handleSave} disabled={buttonDisable || loading}>
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Please wait...
              </span>
            </>
          ) : (
            "Add"
          )}
        </CommonButton>
      </div>
    );
  };

  const poojaTypesDropdown = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          id="selectPooja"
          placeholder="Select Pooja"
          value={selectedPoojaId}
          onChange={(e) => {
            handleDropdowmChange("poojaTitle", e.target.value);
            setErrorMessage({ ...errorMessage, poojaTitle: "", donationAmount: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.poojaTitle ? styles.errorTextField : styles.textField
          }
        >
          {poojaItemsList.map((item, index) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.name}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.poojaTitle ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.poojaTitle}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };
  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.dateOfPooja]);

  const handleDateChange = (field: keyof PoojaItem, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    // setCurrentItem((prevItem) => ({ ...prevItem, [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '' }));
    setFormData({
      ...formData,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM-DD-YYYY")
        : "",
    });
    setErrorMessage({ ...errorMessage, dateOfPooja: "" });
    sessionStorage.setItem(`${field}`, formattedDate.isValid() ? formattedDate.format("MM-DD-YYYY") : "")
  };

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          id="pooja-date"
          sx={{
            backgroundColor: "#FFF9E4",
            borderRadius: "8px",
            height: "48px",
          }}
          onClick={handleDatePickerClick}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={formData.dateOfPooja ? dayjs(formData.dateOfPooja, "MM-DD-YYYY") : ""}
                onChange={(value) => {
                  handleDateChange("dateOfPooja", value);
                }}
                className={
                  errorMessage.dateOfPooja
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.dateOfPooja ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.dateOfPooja}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const onClickPriestSchedule = (priestId: string) => {
    if (formData.dateOfPooja === "" || formData.poojaTime === "") {
      alert("Please select Date and Time");
    } else {
      window.location.href = `${ASP_BASE_URL}/hints/manage/content/asp/token_process.asp?priestName=${formData.selectPriest
        }&devoteeId=${getDevoteeId()?.userId}&dateandtime=${formData.dateOfPooja} ${formData.poojaTime
        }&username=${getUserName() || ""}&token=${getaccessToken() || ""
        }&requestType=P&priestId=${priestId}&userRoleId=${getUserRoleId()}&poojaID=${selectedPoojaId}&location=${formData.poojaLocation
        }&poojaAmount=${donationAmount}&timerequired=${formData.poojaDuration}&poojaName=${poojaName}`;
    }
  };

  // const calculateDonationAmount = (formData: any) => {
  //   const isSelected = selectedItems.length > 0;
  //   const donationAmount = parseFloat(formData.donationAmount);
  //   return isSelected ? (selectedItems.length * donationAmount).toFixed(2) : donationAmount.toFixed(2);
  // };

  const calculateDonationAmount = (currentItem: any): number => {
    const isSelected = selectedItems.length > 0;
    const donationAmount = parseFloat(currentItem.donationAmount);
    return isSelected ? selectedItems.length * donationAmount : donationAmount;
  };

  const calculateDuration = (currentItem: any): number => {
    const isSelected = selectedItems.length > 0;
    const poojaDuration = parseFloat(currentItem.poojaDuration);
    return isSelected ? selectedItems.length * poojaDuration : poojaDuration;
  }

  const handleDonationAmountChange = (inputValue: any) => {
    const maxFieldLimit = constants.Maximum_Field_LIMIT; // Example maximum field limit
    if (inputValue === "") {
      setDonationAmount(inputValue);
      setErrorMessage({
        ...errorMessage,
        donationAmount: "Donation amount is required",
      });
    } else if (Number(inputValue) < 1) {
      setDonationAmount(inputValue);
      setErrorMessage({
        ...errorMessage,
        donationAmount: "Minimum donation amount is 1",
      });
    } else if (inputValue <= maxFieldLimit) {
      setDonationAmount(inputValue);
      setErrorMessage({
        ...errorMessage,
        donationAmount: "",
      });
    }
    // else {
    //   setErrorMessage({
    //     ...errorMessage,
    //     donationAmount: "Maximum donation amount reached",
    //   });
    // }
  };
  

  const fieldsOnAdd = () => {
    return (
      <div className={styles.fieldsRow}>
        {showPriestDropdown ? (
          <div>
            {CustomRequiredInputLabel("Select Priest", true)}
            {priestListDropdown()}
            {showPriestSchedule && !isPastDateTime(`${formData.dateOfPooja} ${formData.poojaTime}`) ? (
              <div
                style={{
                  color: errorMessage.poojaTime ?  "rgba(0, 0, 255, 0.5)" : "blue", // Check if any error exists in the errorMessage object
                  textDecoration: "underline",
                  cursor: errorMessage.poojaTime ? "not-allowed" : "pointer", // Disable pointer if there's an error
                }}
                onClick={() => errorMessage.poojaTime || onClickPriestSchedule(formData.selectPriest)} // Prevent click if there's an error
              >
                See Priest schedule
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        <div>
          {CustomRequiredInputLabel("Suggested Donation Amount", true)}
          <CustomTextFeild
            fullWidth
            required
            // value={calculateDonationAmount(formData)}
            // onChange={(e) => {
            //   let inputValue = e.target.value;
            //   const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
            //   const truncatedValue = numericValue.slice(0, 10); // Allow only the first 10 numbers
            //   if (inputValue === '0') {
            //     inputValue = '';
            //   }
            //   handleFieldChange("donationAmount", truncatedValue);
            //   setErrorMessage({
            //     ...errorMessage,
            //     donationAmount: "",
            //   });
            // }}
            value={donationAmount.toString()}
            onChange={(e) => handleDonationAmountChange(e.target.value.replace(/[^0-9.]/g, ''))}
            className={
              errorMessage.donationAmount
                ? styles.errorTextField
                : styles.textField
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyOutlinedIcon />
                </InputAdornment>
              ),
              // readOnly: true,
            }}
            placeholder="Donation Amount"
          />
          {errorMessage.donationAmount && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.donationAmount}
            </Typography>
          )}
        </div>
        <div>
          {CustomRequiredInputLabel("Pooja Duration (min)", true)}
          <CustomTextFeild
            fullWidth
            required
            // value={formData.poojaDuration}
            value={duration.toString()}
            onChange={(e) => handleFieldChange("poojaDuration", e.target.value)}
            InputProps={{
              readOnly: true,
            }}
            className={styles.textField}
            placeholder="Enter Pooja Duration"
          />
        </div>
      </div>
    );
  };
  const cartContainer = () => {
    return (
      <div className={styles.cartContainer}>
        <div style={{ display: "flex" }}>
          <CommonOutlinedButton
            onClick={props.onBackClick}
            sx={{ marginTop: "10px", marginRight: "10px" }}
          >
            Back to Search Devotee
          </CommonOutlinedButton>
          <div className={styles.text}>Devotee Cart</div>
        </div>
        <IconButton aria-label="cart" onClick={handleCart}>
          <CustomBadge badgeContent={cartItemsList.length} color="secondary">
            <img src={cartIcon} alt="cart Icon" />
          </CustomBadge>
        </IconButton>
      </div>
    );
  };

  const render = () => {
    return (
      <>
        {cartContainer()}
        {fieldsComponent()}
        {buttonsComponent()}
      </>
    );
  };

  const fieldsComponent = () => {
    return (
      <form className={styles.fieldsContainer} autoComplete="off">
        <div className={styles.fieldsRow}>
          <div >
            {CustomRequiredInputLabel("Name", true)}
            <CustomTextFeild
               id="name"
              fullWidth
              required
              value={getDevoteeId()?.fullName?.toUpperCase()}
              className={
                errorMessage.name ? styles.errorTextField : styles.textField
              }
              InputProps={{
                readOnly: true,
              }}
            />
            {errorMessage.name && (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.name}
              </Typography>
            )}
          </div>
        </div>
        <div className={styles.fieldsRow}>
          <div >
            {CustomRequiredInputLabel("Pooja Location", true)}
            <CustomRadioButton
            id="pooja-location"
              checked={formData.poojaLocation === "TEMPLE_POOJA"}
              onChange={() => {
                handleFieldChange("poojaLocation", "TEMPLE_POOJA");
                setErrorMessage({ ...errorMessage, poojaLocation: "", poojaTime: "" });
                setShowDeities(false);
                setShowDetails(false);
                setSelectedPoojaId(null);
                setFormData(prevFormData => ({
                  ...prevFormData,
                  poojaTime: dayjs().format("hh:mm A"),
                  dateOfPooja: dayjs().format("MM-DD-YYYY")
                }))
              }}
            />
            <label className={styles.label}>Temple Pooja</label>
            <CustomRadioButton
              checked={formData.poojaLocation === "OUTSIDE_POOJA"}
              onChange={() => {
                handleFieldChange("poojaLocation", "OUTSIDE_POOJA");
                setErrorMessage({ ...errorMessage, poojaLocation: "", poojaTime: "" });
                setShowDeities(false);
                setShowDetails(false);
                setFormData(prevFormData => ({
                  ...prevFormData,
                  poojaTime: dayjs().format("hh:mm A"),
                  dateOfPooja: dayjs().format("MM-DD-YYYY")
                }))
              }}
            />
            <label className={styles.label}>Outside Pooja</label>
          </div>
          <div >
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }} >
              {CustomRequiredInputLabel("Select Pooja", true)}
              <p
                style={{ 
                  color: selectedPoojaId ? "blue" : "#73737e",
                  margin: "0 0 2px",
                  cursor: selectedPoojaId ? "pointer" : "not-allowed"
                }}
                // onClick={handleOpenDialog}
                onClick={selectedPoojaId ? handleOpenDialog : ()=>{}}
              >
                Details
              </p>
            </div>
            {poojaTypesDropdown()}
          </div>
        </div>

        {showDeities && poojaDeitiesList.length > 0 ? (
          <div>{deitiesListComponent()}</div>
        ) : (
          ""
        )}
        <div className={styles.fieldsRow}>
          <div >
            {CustomRequiredInputLabel("Pooja Date", true)}
            {BasicDatePicker()}
          </div>
          <div>
            <HcccTimePicker
              handleFieldChange={handleFieldChange}
              labelName="Pooja Time"
              fieldName="poojaTime"
              className={
                errorMessage.poojaTime
                  ? styles.errorTextField
                  : styles.textField
              }
              value={formData.poojaTime}
            />
            {errorMessage.poojaTime ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.poojaTime}
              </Typography>
            ) : (
              ""
            )}
          </div>
        </div>
        {showDeities ? fieldsOnAdd() : ""}
      </form>
    );
  };
  const navigateBack = () => {
    getCartItems();
    setShowDeities(false);
    setShowDetails(false);
  };

  const cartComponent = () => {
    return (
      <div>
        <div className={styles.backArrow} style={{ margin: "0px" }}>
          <div onClick={navigateBack} style={{ marginRight: "10px", display: "flex", alignItems: "center" }}>
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>List of Item Added</Typography>
        </div>
        <ManagerCartItemsComponent navigateBack={navigateBack}/>
      </div>
    );
  };
  
  const handleOpenDialog = () => {
    setOpenCancelDialog(true);
  };

  const handleCancelDialogClose = () => {
    setOpenCancelDialog(false);
  };

  const [showButton, setShowButton] = useState(true);
  const handlePrint = () => {
    setShowButton(false);
    setTimeout(() => {
      window.print();
      setShowButton(true);
    }, 0);
  };

  const poojaDetailsComponent = () => {
    const selectedPooja = poojaItemsList.find(item => item.id === selectedPoojaId);
    return (
      <>
        <Grid>
          {/* <Grid>
            {poojaTypesDropdown()}
          </Grid> */}
          {selectedPooja && (
            <table className={styles.tableDetailsContainer}>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Pooja Title</td>
                <td className={styles.contentTableColumn}>: {selectedPooja.name}</td>
              </tr>
              <tr className={styles.headerTableRow} style={{ verticalAlign: "top" }}>
                <td className={styles.headerTableColumn}>Description/Material</td>
                <td className={styles.contentTableColumn}>: {!isNil(selectedPooja.description) ? selectedPooja.description : "-"}</td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Duration</td>
                <td className={styles.contentTableColumn}>: {duration.toString()}</td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Suggested Donation</td>
                <td className={styles.contentTableColumn}>: {donationAmount.toString()}</td>
              </tr>
              <tr className={styles.headerTableRow}>
                <td className={styles.headerTableColumn}>Priest Required</td>
                <td className={styles.contentTableColumn}>: {selectedPooja.priestRequired ? 'Yes' : 'No'}</td>
              </tr>
            </table>

          )}
        </Grid>
        {showButton && <Grid sx={{ marginTop: "10px" }}>
          <CommonButton onClick={handlePrint} className={styles.printHidden}>Print</CommonButton>
        </Grid>}
      </>
    )
  }

  return (
    <>
      <div>
        <div className={styles.PoojaBookingContainer}>
          <Typography component="div" className={styles.typoGraphyHeading}>
            Devotee Service
          </Typography>
          <div className={styles.formContainer}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography component="div" className={styles.typoGraphy}>
                Pooja Booking
              </Typography>
            </Box>
            <Toaster /> {!showList ? render() : cartComponent()}
          </div>
        </div>
        <Dialog
          open={openCancelDialog}
          onClose={handleCancelDialogClose}
          aria-labelledby="cancel-dialog-title"
          PaperProps={{
            style: {
              height: "calc(100% - 128px)",
              width: "calc(100% - 128px)",
              margin: "64px",
              maxWidth: "804px",
              maxHeight: "400px",
              overflowY: "hidden",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            },
          }}
        >
          {/* {loading ? <ClipLoader /> : null} */}
          <div
            style={{
              backgroundColor: "#882E14",
              width: "auto",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Pooja Details"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleCancelDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BounceLoader color="#22A699" loading={loading} size={45} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Please wait...
                </span>
              </div>
            ) : (
              <div>
                {poojaDetailsComponent()}
                {/* {donationSummeryList.length > 0 ? (
                  poojaDetailsComponent()
                ) : (
                  <Typography sx={{ textAlign: "center" }}>No Data</Typography>
                )} */}
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};
export default PoojaBooking;
